import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadJdPowersportHistory } from '../../../store/application/types';
import { AppState } from '../../../store/rootReducer';
import { ColumnInfo, GenericGrid } from '@amsanalytics/react-shared-library';
import { GridFilterCellProps,  GridColumn as Column } from '@progress/kendo-react-grid';
import { createStyles, Theme } from '@mui/material/styles';
import styles from './_jd-powersport-history.module.scss'
// const useStyles: any = makeStyles((theme: Theme) =>
//   createStyles({
//     formControl: {
//       margin: theme.spacing(1),
//       minWidth: 120,
//     },
//     selectEmpty: {
//       marginTop: theme.spacing(2),
//     },
//     textField: {
//       marginLeft: theme.spacing(1),
//       marginRight: theme.spacing(1),
//       width: 200,
//     },
//     visuallyHidden: {
//       border: 0,
//       clip: "rect(0 0 0 0)",
//       height: 1,
//       margin: -1,
//       overflow: "hidden",
//       padding: 0,
//       position: "absolute",
//       top: 20,
//       width: 1
//     },
//     hover: {
//       height: `60px`,// Ensure row height is consistent
//       "&:hover": {
//         cursor: 'pointer'
//       }
//     },
//     gridTitle: {
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'space-between',
//       flexWrap: 'wrap',
//       height: '50px',
//       color: '#3f51b5',
//       margin: 0
//     },
//     gridTitleText: {
//       fontSize: 20,
//       fontWeight: 500
//     }
//   }),
// );

export interface JdPowersportHistoryProps {
  onSelect?: (appId: string) => void;
}

export interface IJdPowersportHistoryItems { 
    make: string,
    model: string,
    year: number,
    modelType: string,
    selectedValue: number,
    vinUsed: string,
    pulledByName: string,
    pulledDate?: Date
}

interface ApplicationQueueGridColumn extends ColumnInfo {
  filtercell?: React.ComponentType<GridFilterCellProps>;
  filterTitle?: string;
}

export default function JdPowersportHistory(props: JdPowersportHistoryProps) {
  const dispatch = useDispatch();
  const currentApp = useSelector((state: AppState) => state.applications.editingApp);
  const jdPowersportHistories = useSelector((state: AppState) => state.applications.jdPowersportHistories);
  const currentUser = useSelector((state: AppState) => state.applications.loggedInUser?.employee);
  
  useEffect(() => {
    if( currentApp){
        dispatch(loadJdPowersportHistory(currentApp.id!));
      }
  }, [currentApp]);

  // List of columns for the generic grid
  const genericGridColumns: ApplicationQueueGridColumn[] = [];
  genericGridColumns.push({ title: "Vin Used", field: "vinUsed", width: '250px' });
  genericGridColumns.push({ title: "Make", field: "make", width: '250px' });
  genericGridColumns.push({ title: "Model", field: "model", width: '250px' });
  genericGridColumns.push({ title: "Model Type", field: "modelType", width: '250px' });
  genericGridColumns.push({ title: "NADA Value", field: "selectedValue", width: '200px' });
  genericGridColumns.push({ title: "Pulled By", field: "pulledByName", width: '250px' });
  genericGridColumns.push({ title: "Updated Date", field: "pulledDate", width: '250px', format: "{0:MMMM d, yyyy h:mm a}" });

  return (
    <div className={styles.jdPowersportHistoryContainer}>
      <div className={styles.gridTitle}>
      </div>
      {true ? (
        <>
          <GenericGrid<IJdPowersportHistoryItems>
            columns={genericGridColumns}
            items={jdPowersportHistories?.map(jd => {
              return {
                ...jd,
                pulledDate: jd.pulledDate ? new Date(jd.pulledDate) : undefined
              }
            }) || []}
            itemName={'JD Powersport History'}
            totalCount={jdPowersportHistories?.length || 0}
            pageSizes={[10, 20, 40]}
            style={{ height: 'calc(100vh - 210px)' }}
            disableAdding={true}
            disableEditing={true}
            disableSorting={true}
            disableGrouping={true}
          />
        </>
      ) : null}
    </div>
  );
}


